<template>
  <div>
    <div class="mode-switch">
      <button class="mode-btn" :class="{ active: po.form.apply_mode === 'bulk' }" @click="po.form.apply_mode = 'bulk'">Ulje e njejte</button>
      <button class="mode-btn" :class="{ active: po.form.apply_mode === 'custom' }" @click="po.form.apply_mode = 'custom'">
        Ulje te ndryshme per produkt
      </button>
    </div>

    <div class="layout-grid" v-if="po.form.apply_mode === 'bulk'">
      <div class="panel-card">
        <div class="section-title">Hapi 1: Cfare ndryshojme?</div>
        <div class="field-grid">
          <label>Fusha e cmimit</label>
          <select v-model="po.form.target_field" class="input-clean">
            <option value="price">Cmimi</option>
            <option value="default_price">Cmimi baze</option>
          </select>

          <label>Lloji i produktit</label>
          <select v-model="po.form.related_entity" class="input-clean">
            <option value="products">Produkte</option>
            <option value="accessories">Aksesore</option>
          </select>

          <template v-if="po.form.apply_mode === 'bulk'">
            <label>Hapi 2: Ku aplikohet?</label>
            <select v-model="po.form.scope" class="input-clean">
              <option value="all">Te gjitha</option>
              <option value="tree">Nga pema e kategorive</option>
              <option value="selected">Produkte te zgjedhura</option>
            </select>

            <label>Hapi 3: Sa eshte ulja?</label>
            <select v-model="po.form.discount_type" class="input-clean">
              <option value="percentage">Perqindje (%)</option>
              <option value="flat">Shume fikse (lek)</option>
              <option value="fixed_price">Cmimi i ri (lek)</option>
            </select>

            <label>{{ po.form.discount_type === "fixed_price" ? "Cmimi i ri (lek)" : "Vlera e uljes" }}</label>
            <input v-model.number="po.form.amount" class="input-clean" type="number" min="0" step="0.01" />
          </template>
        </div>
      </div>

      <div class="panel-card" v-if="po.form.scope === 'tree'">
        <div class="section-title">Hapi 2: Zgjidh kategorine nga pema</div>
        <div class="quick-actions">
          <input v-model="po.treeSearch" class="input-clean" type="text" placeholder="Kerko kategori..." />
          <button class="button is-small" @click="po.clearTreeFilter">Pastro filterin e pemes</button>
        </div>
        <div class="tree-wrap">
          <div
            v-for="node in po.visibleTreeNodes"
            :key="node.guid"
            class="tree-row"
            :class="{ selected: po.form.leaf_guid === node.guid }"
            :style="{ paddingLeft: `${8 + node.depth * 16}px` }"
            @click="po.selectTreeNode(node)"
          >
            <button class="icon-btn" v-if="node.hasChildren" @click.stop="po.toggleNode(node.guid)">
              <i class="fa" :class="po.isCollapsed(node.guid) ? 'fa-plus-square' : 'fa-minus-square'"></i>
            </button>
            <span v-else class="dot">•</span>
            <span class="tree-label">{{ node.name }}</span>
          </div>
          <p v-if="po.visibleTreeNodes.length === 0" class="empty-note">Nuk ka kategori qe perputhen me kerkimin.</p>
        </div>
      </div>

      <div class="panel-card" v-if="po.form.apply_mode === 'bulk' && po.form.scope === 'selected'">
        <div class="section-title">Hapi 2: Zgjidh produktet manualisht</div>
        <input v-model="po.productSearch" class="mb-2 input-clean" type="text" placeholder="Kerko sipas kodit, emrit ose modelit..." />
        <div class="quick-actions">
          <button class="button is-small" @click="po.selectFilteredProducts">Zgjidh te filtruarat</button>
          <button class="button is-small" @click="po.clearSelectedProducts">Pastro zgjedhjet</button>
          <span class="counter">{{ po.form.selected_product_ids.length }} te zgjedhura</span>
        </div>
        <div class="manual-table-wrap">
          <table class="table is-fullwidth is-hoverable is-narrow">
            <thead>
              <tr>
                <th style="width: 32px"></th>
                <th>Kodi</th>
                <th>Emri</th>
                <th class="has-text-right">Cmimi ({{ po.form.target_field === "default_price" ? "baze" : "final" }})</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in po.filteredManualProducts" :key="p.id">
                <td>
                  <input type="checkbox" :checked="po.isSelected(p.id)" @change="po.toggleProductSelection(p.id)" />
                </td>
                <td>{{ p.code }}</td>
                <td>{{ p.name }}</td>
                <td class="has-text-right">{{ po.money(p[po.form.target_field]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="panel-card" v-if="po.form.apply_mode === 'custom'">
      <div class="section-title">Ulje te ndryshme per produkt</div>
      <div class="compact-toolbar">
        <select v-model="po.form.target_field" class="input-clean">
          <option value="price">Cmimi</option>
          <option value="default_price">Cmimi baze</option>
        </select>
        <select v-model="po.form.related_entity" class="input-clean">
          <option value="products">Produkte</option>
          <option value="accessories">Aksesore</option>
        </select>
        <input v-model="po.productSearch" class="input-clean" type="text" placeholder="Kerko produkt..." />
        <button class="button is-small" @click="po.showCustomTreeFilter = !po.showCustomTreeFilter">
          {{ po.showCustomTreeFilter ? "Fshih filtrimin kategori" : "Filtro sipas kategorise" }}
        </button>
        <button class="button is-small" @click="po.clearCustomFilters">Pastro filtrat</button>
        <button class="button is-small" @click="po.clearCustomRules">Pastro ndryshimet</button>
      </div>

      <div v-if="po.showCustomTreeFilter" class="compact-tree-filter">
        <div class="quick-actions">
          <input v-model="po.treeSearch" class="input-clean" type="text" placeholder="Kerko kategori..." />
          <button class="button is-small" @click="po.clearTreeFilter">Pastro pemen</button>
        </div>
        <div class="tree-wrap compact-tree">
          <div
            v-for="node in po.visibleTreeNodes"
            :key="node.guid"
            class="tree-row"
            :class="{ selected: po.form.leaf_guid === node.guid }"
            :style="{ paddingLeft: `${8 + node.depth * 16}px` }"
            @click="po.selectTreeNode(node)"
          >
            <button class="icon-btn" v-if="node.hasChildren" @click.stop="po.toggleNode(node.guid)">
              <i class="fa" :class="po.isCollapsed(node.guid) ? 'fa-plus-square' : 'fa-minus-square'"></i>
            </button>
            <span v-else class="dot">•</span>
            <span class="tree-label">{{ node.name }}</span>
          </div>
        </div>
      </div>

      <div class="quick-actions">
        <span class="counter">{{ po.customChangedCount }} produkte me ndryshim</span>
        <button
          v-for="page in po.customPageButtons"
          :key="`p-${page}`"
          class="button is-small"
          :class="{ 'is-info': po.customPage === page }"
          @click="po.customPage = page"
        >
          {{ page }}
        </button>
        <span class="counter">Faqe {{ po.customPage }} / {{ po.customTotalPages }}</span>
      </div>

      <div class="manual-table-wrap">
        <table class="table is-fullwidth is-narrow">
          <thead>
            <tr>
              <th>Kodi</th>
              <th>Emri</th>
              <th class="has-text-right">Cmimi bazë</th>
              <th style="width: 170px">Lloji</th>
              <th style="width: 130px">Vlera</th>
              <th style="width: 36px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in po.paginatedCustomProducts" :key="row.id">
              <td>{{ row.code }}</td>
              <td>{{ row.name }}</td>
              <td class="has-text-right">{{ po.money(row[po.form.target_field]) }}</td>
              <td>
                <select :value="po.getCustomRule(row.id).discount_type" @change="po.setCustomRuleType(row.id, $event.target.value)" class="input-clean">
                  <option value="percentage">Perqindje (%)</option>
                  <option value="flat">Fikse (lek)</option>
                  <option value="fixed_price">Cmimi i ri (lek)</option>
                </select>
              </td>
              <td>
                <input
                  :value="po.getCustomRule(row.id).amount"
                  @input="po.setCustomRuleAmount(row.id, $event.target.value)"
                  class="input-clean"
                  type="number"
                  min="0"
                  step="0.01"
                />
              </td>
              <td>
                <span v-if="po.isCustomChanged(row.id)" class="text-green-600"><i class="fa fa-check"></i></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="sticky-actions">
      <div class="sticky-summary">
        <strong>Hapi final:</strong>
        <span>{{ po.previewRows.length }} produkte ne parashikim</span>
        <span>•</span>
        <span>{{ po.selectedPreviewIds.length }} te zgjedhura per aplikim</span>
        <span v-if="po.manualOverScheduleCap" class="audit-secondary" style="margin:0">
          Planifikimi ndahet në {{ po.manualScheduleSplits }} batch-e (max {{ po.priceScheduleItemCap }})
        </span>
      </div>
      <div class="actions-row">
        <button class="button" @click="po.refreshPreview">Parashiko</button>
        <button
          class="button is-success"
          :class="{ 'is-loading': po.applyLoading }"
          :disabled="!po.canApply || po.applyLoading"
          @click="po.requestApplyDiscount"
        >
          Apliko dhe sinkronizo Financa 1 + 2
        </button>
      </div>
    </div>

    <div class="panel-card" v-if="po.previewRows.length">
      <div class="section-title">Parashikim i ndryshimeve ({{ po.selectedPreviewIds.length }}/{{ po.previewRows.length }} te zgjedhura)</div>
      <div class="quick-actions">
        <button class="button is-small" @click="po.selectAllPreview">Zgjidh te gjitha</button>
        <button class="button is-small" @click="po.clearPreviewSelection">Pastro zgjedhjen</button>
      </div>
      <div class="preview-table-wrap">
        <table class="table is-fullwidth is-striped is-narrow">
          <thead>
            <tr>
              <th style="width: 32px"></th>
              <th>Kodi</th>
              <th>Emri</th>
              <th class="has-text-right">Vlera aktuale</th>
              <th class="has-text-right">Vlera e re</th>
              <th style="width: 34px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in po.previewRows" :key="row.id">
              <td><input type="checkbox" :checked="po.selectedPreviewIds.includes(row.id)" @change="po.togglePreviewSelection(row.id)" /></td>
              <td>{{ row.code }}</td>
              <td>{{ row.name }}</td>
              <td class="has-text-right">{{ po.money(row.base_value) }}</td>
              <td class="has-text-right">{{ po.money(row.new_price) }}</td>
              <td>
                <button class="icon-btn" @click="po.removeFromPreview(row.id)" title="Hiq nga perditesimi"><i class="fa fa-times"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="result-card" v-if="po.applyResult">
      <div class="result-item"><strong>Targetuar:</strong> {{ po.applyResult.targeted }}</div>
      <div class="result-item"><strong>Perditesuar:</strong> {{ po.applyResult.updated }}</div>
      <div class="result-item"><strong>Financa 1 + Financa 2 OK:</strong> {{ po.applyResult.synced_ok }}</div>
      <div class="result-item"><strong>Financa 1 / Financa 2 dështuar:</strong> {{ po.applyResult.synced_failed }}</div>
      <div class="preview-table-wrap" v-if="po.applyResult.failed_sync && po.applyResult.failed_sync.length">
        <table class="table is-fullwidth is-narrow">
          <thead>
            <tr>
              <th>Kodi</th>
              <th>Financa</th>
              <th>Status</th>
              <th>Arsyeja</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(f, i) in po.applyResult.failed_sync" :key="`msync-${f.product_id}-${f.erp || ''}-${i}`">
              <td>{{ f.code }}</td>
              <td>{{ po.erpLabel(f.erp) }}</td>
              <td>{{ f.status || "-" }}</td>
              <td>{{ f.reason || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManualDiscountPanel",
  inject: ["po"],
};
</script>
